import { createContext } from 'react';

const state = {
  sb: null,
  currentUser: null,
};

const ChatContext = createContext(state);

export default ChatContext;
